// extracted by mini-css-extract-plugin
export default {"wrapper":"MinimizeMaximizeArrows_wrapper__YviDX","icon":"MinimizeMaximizeArrows_icon__OAyZD","disabledIcon":"MinimizeMaximizeArrows_disabledIcon__HI3xc"};